import filter from "lodash-es/filter"
import isEmpty from "lodash-es/isEmpty"

import { ESessionModality, EUserRole } from "@/3514/types"

import renderers from "./session-info.renderers.actions"
import type {
    TSelectInfoDropdownItem as TDropdownItem,
    _TSessionInfoRenderFunctionSharedExternalParams as TRenderFunctionExternalParams,
    _TSessionInfoRenderFunctionSharedInternalParams as TRenderFunctionInternalParams
} from "./session-info.types"

function participantActions(
    internal: TRenderFunctionInternalParams,
    external: TRenderFunctionExternalParams
): TDropdownItem[] {
    return filter<TDropdownItem>(
        [
            Boolean(internal.data.session.isSwappable && !internal.data.session.isCancelled) &&
                renderers.renderSwapSessionActionProps({ ...internal, ...external }),

            Boolean(
                internal.sessionTimeState.isUpcoming &&
                    !internal.data.session.isCancelled &&
                    internal.data.session.modality === ESessionModality.Individual
            ) && renderers.renderCancelSessionActionProps({ ...internal, ...external }),

            Boolean(
                !internal.data.session.isMissed &&
                    internal.sessionTimeState.isUpcoming &&
                    internal.data.session.isReschedulable &&
                    !internal.data.session.isCancelled
            ) && renderers.renderScheduleSessionActionProps({ ...internal, ...external })
        ],
        Boolean
    )
}

function coachActions(
    internal: TRenderFunctionInternalParams,
    external: TRenderFunctionExternalParams
): TDropdownItem[] {
    const _isIndividualSession: boolean = internal.data.session.modality === ESessionModality.Individual

    return filter<TDropdownItem>(
        [
            Boolean(
                _isIndividualSession && internal.data.session.isMissed && internal.data.session.isAttendanceMarked
            ) && renderers.renderGiftSessionActionProps({ ...internal, ...external }),

            Boolean(
                internal.sessionTimeState.isUpcoming &&
                    !internal.sessionTimeState.isLive &&
                    !internal.data.session.isCancelled &&
                    _isIndividualSession
            ) && renderers.renderCancelSessionActionProps({ ...internal, ...external }),

            Boolean(
                !internal.data.session.isCancelled &&
                    !internal.data.session.isMissed &&
                    internal.sessionTimeState.isUpcoming &&
                    internal.data.session.isReschedulable &&
                    _isIndividualSession &&
                    !isEmpty(internal.data.session.startDate)
            ) && renderers.renderScheduleSessionActionProps({ ...internal, ...external }),

            Boolean(
                (internal.sessionTimeState.isUpcoming || internal.sessionTimeState.isPast) &&
                    !internal.data.session.isCancelled &&
                    internal.data.session.isAttendanceMarked
            ) && renderers.renderAttendanceActionProps({ ...internal, ...external })
        ],
        Boolean
    )
}

export default {
    [EUserRole.Participant]: participantActions,
    [EUserRole.Assistant]: participantActions,
    [EUserRole.Coach]: coachActions,
    [EUserRole.Manager]: coachActions
}
